<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full mb-20"
      :bodyStyle="{ paddingTop: '20px' }"
    >
      <template #title>
        <h6>Teaching records</h6>
        <small
          >Select teaching record details and upload the reference file.</small
        >
      </template>
      <a-form :layout="'horizontal'">
        <a-form-item
          label="Term year"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            show-search
            placeholder="select term year ..."
            :filter-option="filterOption"
            v-model="selectYear"
          >
            <a-select-option
              v-for="(item, index) in optionYear"
              :key="'Year' + index"
              :value="item.id"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Course"
          placeholder="select course ..."
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
          help="Please contact : Tel. +66 (0) 2700 5000 Ext. 4205 , 4206 , 4208 If you could not find needed course."
        >
          <a-select
            show-search
            placeholder="select course ..."
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="selectCourse"
          >
            <a-select-option
              v-for="(item, index) in optionSection"
              :key="'course' + index"
              :value="item.id"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Section"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            show-search
            placeholder="select section ..."
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="selectSec"
          >
            <a-select-option
              v-for="(item, index) in optionSec"
              :key="`sec` + index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="Teaching period"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
        >
          <a-select
            show-search
            placeholder="select periods ..."
            option-filter-prop="children"
            :filter-option="filterOption"
            v-model="selectPeriods"
          >
            <a-select-option
              v-for="(item, index) in optionPeriod"
              :key="`period` + index"
              :value="item.id"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          class="mb-20"
          label="Attachments"
          :label-col="{ span: 4 }"
          :wrapper-col="{ span: 12 }"
          help="Teaching record file can be screenshots of meeting logs or meeting screens. File types that can be uploaded are .pdf"
        >
          <a-upload
            :file-list="fileList"
            :remove="handleRemove"
            :before-upload="beforeUpload"
            :multiple="false"
            v-model="fileUpload"
          >
            <a-button> <a-icon type="upload" /> Select File </a-button>
          </a-upload>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button @click="visible = true" type="primary" class="mr-10">
            Submit
          </a-button>
          <a-button @click="backToTeaching" type="danger"> Cancel </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-modal
      title="Confirm"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submitTeachingLog"
      @cancel="visible = false"
    >
      <p>Are you sure to Submit ?</p>
    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // modal
      visible: false,
      confirmLoading: false,
      // option
      optionYear: [],
      optionPeriod: [],
      optionTerm: [],
      optionSection: [],
      optionSec: [],
      // form
      selectYear: "",
      selectPeriods: "",
      selectCourse: "",
      selectSec: "",
      // file upload
      fileList: [],
      uploading: false,
      fileUpload: null,
    };
  },
  computed: {},
  mounted() {
    this.getYear();
    this.getPeriod();
  },
  watch: {
    selectYear(val) {
      if (val !== "") {
        this.selectCourse = "";
        this.selectSec = "";
        this.optionSec = [];
        this.getCourse(val);
      }
    },
    selectCourse(val) {
      if (val !== "") {
        this.getSection(val);
      }
    },
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      this.fileUpload = file;
      this.fileList = [...this.fileList, file];
      return false;
    },
    backToTeaching() {
      this.$router
        .push({
          path: "/teaching",
        })
        .catch((err) => {});
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .includes(input.toLowerCase())
      );
    },
    async getYear() {
      this.optionYear = [];
      try {
        const res = await this.$http.get("/teaching/course/term_year/");
        this.optionYear = res.data.map((item) => {
          return {
            id: `${item.term_year}`,
            text: `${item.term_year}`,
          };
        });
        this.optionYear.sort(function (a, b) {
          let nameA = a.id.toUpperCase();
          let nameB = b.id.toUpperCase();
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }
          return 0;
        });
      } catch (error) {
        this.optionYear = [];
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Problem issue connect api : /teaching/course/term_year/`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
      }
    },
    async getPeriod() {
      this.optionPeriod = [];
      try {
        const res = await this.$http.get("/teaching/note_period/");
        this.optionPeriod = res.data.map((item) => {
          return {
            id: item.id,
            text: item.period + " ( " + item.type_around + " )",
          };
        });
        this.optionPeriod.sort((a, b) => {
          return b.id - a.id;
        });
      } catch (error) {
        this.optionPeriod = [];
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Problem issue connect api : /teaching/note_period/`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
      }
    },
    async getCourse(val) {
      this.optionSection = [];
      try {
        const res = await this.$http.get(`/teaching/course/?term_year=${val}`);
        if (res.status === 200) {
          // code
          this.optionSection = res.data.map((item) => {
            return {
              ...item,
              id: `${item.subject}`,
              text: `${item.subject}`,
            };
          });
          this.optionSection.sort(function (a, b) {
            let nameA = a.id.toUpperCase();
            let nameB = b.id.toUpperCase();
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          });
        }
      } catch (error) {
        this.optionSection = [];
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Problem issue connect api : /teaching/course/?term_year=${val}`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
      }
    },
    getSection(val) {
      const match = this.optionSection.find((a) => a.subject === val);
      this.optionSec = match?.section || [];
    },
    openNotification(args) {
      this.$notification.open({
        style: {
          backgroundColor: args.backgroundColor,
          color: args.color,
        },
        message: function (h) {
          return h("div", [h("strong", { class: "" }, args.title)]);
        },
        description: args.msg,
      });
    },
    async submitTeachingLog() {
      const sendData = new FormData();
      sendData.append("term", this.selectYear);
      sendData.append("course", this.selectCourse);
      sendData.append("section", this.selectSec);
      sendData.append("around", this.selectPeriods);
      sendData.append("upload_file", this.fileUpload);
      try {
        const response = await this.$http.post(
          "/teaching/note/add/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 200) {
          this.visible = false
          this.$router.replace("/teaching");
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.visible = false
        this.openNotification({
          title: `Error ${error.response.status}`,
          msg: `Problem issue connect api : /teaching/note/add/`,
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
      }
    },
  },
};
</script>